import { defineComponent as _defineComponent } from 'vue'
import CModal from './CModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CErrorModal',
  props: {
    isOpen: { type: Boolean },
    title: null,
    modalErrorDescription: null,
    errorMessage: null,
    handleClose: null
  },
  emits: ["error-message-copied", "failed-to-copy-error"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'error-message-copied'): void;
    (event: 'failed-to-copy-error', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    isOpen: boolean;
    title: string;
    modalErrorDescription: string;
    errorMessage: string;
    handleClose: () => void;
};





const copyErrorMessage = async () => {
    try {
        const msgToCopy = props.errorMessage.replaceAll('\n\n\n', '\n\n');
        if (!msgToCopy) {
            return;
        }
        await navigator.clipboard.writeText(msgToCopy);
        emits('error-message-copied');
    } catch (error) {
        emits('failed-to-copy-error', (error as Error).message);
    }
};

return { __sfc: true,props, emits, copyErrorMessage, CModal }
}

})